import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";
import useHasPermissionForRoute from "../../utils/useHasPermissionForRoute";
import { getPermissionsRequest } from "../../redux/actions/Company";
import { useDispatch, useSelector } from "react-redux";


const ProtectedPermission = ({ children, requiredPermission }) => {
  const permissions = useHasPermissionForRoute(); 

  const hasPermission = Array.isArray(requiredPermission)
    && requiredPermission.some((required) =>
        permissions.some((perm) => perm.name === required)
      )

  if (!hasPermission) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
};

export default ProtectedPermission;

